import PropTypes from 'prop-types';
import React from 'react';

// lib
import states from '../../../lib/states';

class StateSelect extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string
  }

  render() {
    return (
      <select { ...this.props }>
        <option disabled={ true } value='placeholder'>{ this.props.placeholder }</option>
        { this._renderStates() }
      </select>
    );
  }

  // private

  _renderStates() {
    const options = [];

    for (let i = 0; i < states.length; i++) {
      const state = states[i];

      options.push(
        <option key={ state.abbreviation }
          value={ state.abbreviation }>{ state.name }</option>
      );
    }

    return options;
  }
}

export default StateSelect;



// WEBPACK FOOTER //
// ./app/components/shared/form/_StateSelect.jsx